import { gql } from '@apollo/client'

export const GOAL_GROUP_CARDS = gql`
  query goalGroupCardsInfo($funderOrgId: Int!, $goalGroupId: Int) {
    goalGroupCards(funderOrgId: $funderOrgId, goalGroupId: $goalGroupId) {
      category
      completedTasks
      description
      endDate
      goalGroupId
      numGrantees
      startDate
      target
      targetDescription
      targetProgress
      totalTasks
      title
      isFunderAssigned
    }
  }
`
